const fr = {
  // Navbar
  "nav.agentia": "L'Agent IA",
  "nav.sectors": "Secteurs",
  "nav.pricing": "Tarifs",
  "nav.contact": "Contact",

  // Hero - UPDATED: "Agent IA" instead of "Employé IA" in title
  "hero.badge": "✦ Propulsé par AIPreneur",
  "hero.title.1": "Déployez un agent IA",
  "hero.title.2": "vocal et textuel",
  "hero.title.3": "qui travaille pour vous 24h/24, 7j/7.",
  "hero.subtitle": "Un employé IA sur-mesure pour vos usages internes et externes. Captez des leads, assistez vos équipes, automatisez votre support client.",
  "hero.cta.primary": "Découvrir l'agent IA",
  "hero.cta.secondary": "Voir les tarifs",

  // Stats - UPDATED: 95% satisfaction
  "stats.sectors": "Secteurs couverts",
  "stats.availability": "Flux traités",
  "stats.response": "Temps de réponse",
  "stats.costs": "Satisfaction",

  // Features (L'Agent section on homepage)
  "features.title": "Tout ce dont votre entreprise a besoin",
  "features.1.title": "Agent Externe (Clients)",
  "features.1.desc": "Captez des leads, répondez aux clients 24/7 et automatisez le suivi des commandes.",
  "features.2.title": "Multi-langue",
  "features.2.desc": "FR, EN, ES, AR et +50 langues supportées nativement.",
  "features.3.title": "Intégrations natives",
  "features.3.desc": "CRM, e-mail, WhatsApp, Slack, n8n, Make. Symbiose parfaite.",
  "features.4.title": "Agent Interne (Équipe)",
  "features.4.desc": "Centralisez les processus internes, formez vos équipes et accélérez la productivité.",
  "features.5.title": "Escalade humaine intelligente",
  "features.5.desc": "Transfert vers agent humain si nécessaire, sans friction.",
  "features.6.title": "Dashboard Analytique",
  "features.6.desc": "Suivez les conversions, analysez les économies réalisées et pilotez la performance en temps réel.",

  // Chat Demo
  "chat.title": "Voyez votre Agent IA en action",
  "chat.status": "Agent AIpreneur · En ligne",
  "chat.msg1": "Bonjour, quels sont vos horaires ?",
  "chat.msg2": "Bonjour ! Nous sommes disponibles 24h/24, 7j/7. Comment puis-je vous aider ?",
  "chat.msg3": "J'ai un souci avec ma commande #4521",
  "chat.msg4": "Je localise votre commande. Livraison prévue demain avant 18h. Souhaitez-vous être notifié ?",
  "chat.resolved": "Résolu en 8 secondes · 0 intervention humaine",

  // Testimonials
  "testimonials.title": "Ce qu'ils en disent",
  "testimonials.1.quote": "L'Agent répond à mes clients avec plus d'élégance que certains de mes vendeurs. Déploiement en 2 semaines.",
  "testimonials.1.name": "Marie D.",
  "testimonials.1.role": "DG · Boutique Joaillerie",
  "testimonials.2.quote": "Notre LTV a augmenté de 34% depuis le déploiement. L'Agent qualifie et nourrit notre CRM en temps réel.",
  "testimonials.2.name": "Thomas R.",
  "testimonials.2.role": "CTO · SaaS FinTech",
  "testimonials.3.quote": "Nos patients sont pris en charge à toute heure. RGPD parfaitement respecté. Indispensable.",
  "testimonials.3.name": "Sophie M.",
  "testimonials.3.role": "Directrice · Clinique Privée",
  "testimonials.1.sector": "Luxe",
  "testimonials.2.sector": "FinTech",
  "testimonials.3.sector": "Santé",

  // FAQ (homepage)
  "faq.title": "Questions fréquentes",
  "faq.1.q": "Combien de temps prend le déploiement ?",
  "faq.1.a": "Temps de déploiement variable : généralement entre 1 et 2 semaines pour les cas les plus complexes.",
  "faq.2.q": "Mon secteur est-il compatible ?",
  "faq.2.a": "L'Agent AIpreneur s'adapte à plus de 30 secteurs. Si le vôtre n'est pas listé, contactez-nous pour un déploiement sur-mesure.",
  "faq.3.q": "Puis-je personnaliser le ton de l'Agent ?",
  "faq.3.a": "Absolument. Ton, vocabulaire, niveau de formalité, langue — chaque paramètre est calibré sur votre identité de marque.",
  "faq.4.q": "L'Agent remplace-t-il mes équipes ?",
  "faq.4.a": "Non. L'Agent augmente vos équipes. Il traite les flux répétitifs et escalade intelligemment vers l'humain quand nécessaire.",
  "faq.5.q": "Quels canaux sont supportés ?",
  "faq.5.a": "Web, WhatsApp, email, Slack, QR codes, téléphone, API personnalisées. L'Agent vit partout où vos clients communiquent.",
  "faq.6.q": "Comment fonctionne la facturation ?",
  "faq.6.a": "Agent textuel : formules mensuelles. Agent vocal : setup + facturation à l'usage. Sans engagement minimum.",
  "faq.7.q": "Puis-je tester avant de m'engager ?",
  "faq.7.a": "Oui. Contactez-nous pour une démonstration personnalisée avec votre cas d'usage réel.",
  "faq.8.q": "Quelles zones géographiques couvrez-vous ?",
  "faq.8.a": "France, Luxembourg, Belgique, Suisse, Maroc, Algérie et Tunisie.",

  // HomeCTA
  "cta.title": "Prêt à déployer votre Agent IA ?",
  "cta.subtitle": "Déploiement en 1 à 2 semaines. Sans engagement.",
  "cta.primary": "Voir les tarifs",
  "cta.secondary": "Réserver un appel",

  // Footer
  "footer.tagline": "L'Agent IA sur-mesure pour votre entreprise.",
  "footer.powered": "Propulsé par AIPreneur",
  "footer.nav": "Navigation",
  "footer.home": "Accueil",
  "footer.zones.title": "Zones couvertes",
  "footer.zones": "France, Luxembourg, Belgique, Suisse, Maroc, Algérie, Tunisie",
  "footer.legal.title": "Légal",
  "footer.mentions": "Mentions légales",
  "footer.privacy": "Politique de confidentialité",
  "footer.rights": "© 2026 AIPreneur. Tous droits réservés.",

  // ═══ PAGE: L'AGENT ═══
  "agent.hero.badge": "✦ La Plateforme",
  "agent.hero.title.1": "Votre Agent IA +",
  "agent.hero.title.2": "Dashboard complet.",
  "agent.hero.subtitle": "Un contrôle total via un tableau de bord clair pour piloter votre Agent IA, suivre les requêtes, voir les statistiques de conversion et analyser les performances de votre équipe et les économies réalisées.",

  "agent.anatomie.title": "L'Anatomie d'une Action",
  "agent.anatomie.subtitle": "Ce n'est pas une conversation. C'est une décision.",
  "agent.step1.title": "L'Impulsion",
  "agent.step1.desc": "Une demande arrive. L'Agent absorbe l'intention en 0.3s — au-delà du langage, au-delà du canal.",
  "agent.step1.badge": "0.3s",
  "agent.step2.title": "La Synthèse",
  "agent.step2.desc": "L'Agent traverse votre base de données métier. Il ne cherche pas — il sait.",
  "agent.step2.badge": "Analyse",
  "agent.step2.pills": "Airtable,CRM,Base Métier",
  "agent.step3.title": "L'Exécution",
  "agent.step3.desc": "Contrat envoyé. Agenda réservé. Prospect qualifié. Zéro intervention humaine.",
  "agent.step3.badge": "Accompli",

  "agent.memoire.title": "La Mémoire Cognitive",
  "agent.memoire.subtitle": "Chaque interaction est une leçon. L'Agent extrait l'essence de chaque conversation, qualifie l'intention et nourrit votre CRM en temps réel.",
  "agent.memoire.scoring": "SCORING INTUITIF",
  "agent.memoire.scoring.sub": "Intention détectée",
  "agent.memoire.tag1": "#Achat",
  "agent.memoire.tag2": "#Urgent",
  "agent.memoire.tag3": "#B2B",
  "agent.memoire.tag4": "#France",
  "agent.memoire.tag5": "#Premium",
  "agent.memoire.extraction": "Extraction d'Intentions",
  "agent.memoire.crm.title": "Flux CRM Temps Réel",
  "agent.memoire.crm.1": "Entreprise X — Ajouté il y a 2s",
  "agent.memoire.crm.2": "Lead #1247 — Score: 91 — Qualifié",
  "agent.memoire.crm.3": "Entreprise Y — Relance programmée",
  "agent.memoire.crm.4": "Lead #1248 — Score: 78 — En cours",
  "agent.memoire.terminal.q": "> Combien de leads qualifiés cette semaine ?",
  "agent.memoire.terminal.a": "→ 47 prospects. Taux d'intention élevé : 68%",
  "agent.memoire.terminal.title": "Dialogue avec la Data",
  "agent.memoire.ind1": "Achat imminent",
  "agent.memoire.ind2": "Profil B2B",
  "agent.memoire.ind3": "Émotion +",

  "agent.tissu.title": "Le Tissu Conjonctif",
  "agent.tissu.subtitle": "L'Agent s'adapte à votre monde, pas l'inverse. Une symbiose parfaite propulsée par n8n, Make, API sur-mesure.",
  "agent.tissu.sub2": "L'expertise de 5 ans d'AIPreneur au cœur de chaque connexion.",
  "agent.tissu.pill1": "n8n natif",
  "agent.tissu.pill2": "Make",
  "agent.tissu.pill3": "API sur-mesure",

  "agent.instinct.title": "L'Instinct — Au-delà du modèle",
  "agent.instinct.subtitle": "L'Agent ne vous demande pas quel modèle choisir. Il choisit seul — le plus précis, le plus rapide, le plus économe — à chaque instant, en silence.",
  "agent.instinct.center": "Instinct AIpreneur",

  "agent.cta.title": "Donnez vie à votre Agent IA",
  "agent.cta.subtitle": "1 à 2 semaines pour déployer une intelligence qui comprend, décide et agit.",

  // ═══ PAGE: SECTEURS ═══
  "secteurs.hero.title.1": "30+ secteurs,",
  "secteurs.hero.title.2": "une seule solution.",
  "secteurs.hero.subtitle": "L'Agent AIpreneur s'adapte à votre métier en absorbant votre ADN professionnel.",
  "secteurs.search.placeholder": "Recherchez votre secteur...",

  "secteurs.meta.title": "Cas d'usage concrets",
  "secteurs.meta.subtitle": "Trois univers. Trois personnalités. Un seul Agent.",
  "secteurs.meta.1.title": "E-commerce",
  "secteurs.meta.1.tone": "Réactif · Précis · Disponible",
  "secteurs.meta.1.client": "Où en est ma commande #4521 ?",
  "secteurs.meta.1.entity": "Votre commande est en cours de livraison. Arrivée prévue demain avant 18h.",
  "secteurs.meta.2.title": "Santé",
  "secteurs.meta.2.tone": "Bienveillant · Rassurant · Confidentiel",
  "secteurs.meta.2.client": "Je souhaite prendre rendez-vous pour un bilan.",
  "secteurs.meta.2.entity": "Bien sûr. Je vous propose un créneau adapté. Toutes vos données restent confidentielles.",
  "secteurs.meta.3.title": "Banque & Finance",
  "secteurs.meta.3.tone": "Précis · Sécurisé · Rapide",
  "secteurs.meta.3.client": "Quel est le solde de mon compte courant ?",
  "secteurs.meta.3.entity": "Votre solde est de 3 247,50€. Souhaitez-vous voir vos dernières opérations ?",

  "secteurs.process.title": "Le Processus d'Assimilation",
  "secteurs.process.subtitle": "Comment l'Agent apprend un nouveau métier — en silence, en profondeur.",
  "secteurs.process.1.title": "L'Ingestion",
  "secteurs.process.1.desc": "Connexion à vos données métier via n8n/Make. L'Agent absorbe sans juger.",
  "secteurs.process.1.pills": "n8n,Make,API",
  "secteurs.process.2.title": "L'Alignement",
  "secteurs.process.2.desc": "Calibrage du ton, du lexique et de la personnalité. L'Agent s'efface pour devenir vous.",
  "secteurs.process.2.pills": "Ton,Lexique,Personnalité",
  "secteurs.process.3.title": "Le Déploiement",
  "secteurs.process.3.desc": "L'Agent devient autonome. Il fluidifie vos processus et grandit avec votre métier.",
  "secteurs.process.3.badge": "1-2 semaines · Autonome · En croissance",

  "secteurs.cta.title": "Votre secteur mérite un Agent à sa mesure",
  "secteurs.cta.subtitle": "Découvrez comment l'Agent AIpreneur s'adapte à votre réalité.",

  "secteurs.default.badge": "Métier sur-mesure",
  "secteurs.default.entity": "Votre secteur est unique. L'Agent s'y alignera en 1 à 2 semaines.",
  "secteurs.response.tone": "Ton adapté",

  // ═══ PAGE: TARIFS ═══
  "tarifs.hero.badge": "✦ Trois formules adaptées à vos ambitions",
  "tarifs.hero.title": "Investissez dans votre croissance.",
  "tarifs.hero.subtitle": "Agent IA textuel ou vocal — choisissez la formule adaptée à vos besoins.",
  "tarifs.toggle.monthly": "Mensuel",
  "tarifs.toggle.annual": "Annuel",
  "tarifs.toggle.save": "-20%",

  "tarifs.clarte.title": "Clarté absolue",
  "tarifs.clarte.subtitle": "Pas de frais cachés. Pas de surprises. Chaque formule est transparente.",
  "tarifs.clarte.1.title": "Sans engagement",
  "tarifs.clarte.1.desc": "Résiliez quand vous voulez, sans pénalité.",
  "tarifs.clarte.2.title": "Déploiement inclus",
  "tarifs.clarte.2.desc": "Configuration, personnalisation et mise en production comprises.",
  "tarifs.clarte.3.title": "Formation incluse",
  "tarifs.clarte.3.desc": "Accompagnement pour votre équipe.",
  "tarifs.clarte.4.title": "Mises à jour continues",
  "tarifs.clarte.4.desc": "Votre Agent évolue avec les derniers modèles LLM.",

  "tarifs.cta.title": "Prêt à passer à la vitesse supérieure ?",
  "tarifs.cta.subtitle": "Contactez-nous pour une démonstration personnalisée.",

  "tarifs.guarantee.1": "Satisfait ou remboursé 30 jours",
  "tarifs.guarantee.2": "Déploiement garanti 1-2 semaines",
  "tarifs.guarantee.3": "Accompagnement dédié",
  "tarifs.guarantee.4": "RGPD Natif",

  "tarifs.faq.title": "Questions sur les formules",
  "tarifs.faq.1.q": "Puis-je changer de formule en cours de route ?",
  "tarifs.faq.1.a": "Oui, vous pouvez évoluer vers une formule supérieure à tout moment. La différence est calculée au prorata.",
  "tarifs.faq.2.q": "Que se passe-t-il si je dépasse mes conversations mensuelles ?",
  "tarifs.faq.2.a": "Nous vous alertons avant d'atteindre la limite. Vous pouvez upgrader ou acheter des conversations supplémentaires.",
  "tarifs.faq.3.q": "Le déploiement est-il vraiment inclus ?",
  "tarifs.faq.3.a": "Oui. Configuration complète, personnalisation du ton et intégration à vos flux existants. Tout est inclus.",
  "tarifs.faq.4.q": "Y a-t-il un contrat minimum ?",
  "tarifs.faq.4.a": "Non. Engagement mensuel sans minimum. Vision Annuelle avec -20% de remise.",

  // ═══ PAGE: CONTACT ═══
  "contact.hero.badge": "✦ Parlons de votre projet",
  "contact.hero.title": "Déployez votre Agent IA.",
  "contact.hero.subtitle": "Remplissez le formulaire ci-dessous et notre équipe vous recontacte sous 24h.",
  "contact.calendly.title": "Ou réservez directement un créneau",
  "contact.calendly.cta": "Réserver sur Calendly",
  "contact.info.title": "Informations",
  "contact.info.email": "contact@aipreneur.ma",
  "contact.info.location": "France, Luxembourg, Belgique, Suisse, Maroc, Algérie, Tunisie",
  "contact.info.certif": "Interventions en présentiel et à distance",

  // ═══ PAGE: MENTIONS LÉGALES ═══
  "legal.title": "Mentions légales",
  "legal.editor.title": "Éditeur du site",
  "legal.editor.text": "AIPreneur SAS\nSiège social : France\nSIRET : En cours d'immatriculation\nDirecteur de la publication : AIPreneur",
  "legal.hosting.title": "Hébergement",
  "legal.hosting.text": "Le site est hébergé au sein de l'Union Européenne, conformément aux exigences RGPD.\nHébergeur : Hostinger International Ltd.\nAdresse : 61 Lordou Vironos, 6023 Larnaca, Chypre",
  "legal.ip.title": "Propriété intellectuelle",
  "legal.ip.text": "L'ensemble des contenus présents sur le site aipreneur.fr (textes, images, logos, vidéos, code source) sont protégés par le droit d'auteur et restent la propriété exclusive d'AIPreneur SAS.",
  "legal.liability.title": "Responsabilité",
  "legal.liability.text": "AIPreneur s'efforce d'assurer l'exactitude des informations publiées. Toutefois, aucune garantie n'est donnée quant à l'exhaustivité ou l'actualité de ces informations.",

  // ═══ PAGE: CONFIDENTIALITÉ ═══
  "privacy.title": "Politique de confidentialité",
  "privacy.intro.title": "Introduction",
  "privacy.intro.text": "AIPreneur SAS s'engage à protéger la vie privée de ses utilisateurs.",
  "privacy.data.title": "Données collectées",
  "privacy.data.text": "Nous collectons uniquement les données nécessaires au bon fonctionnement de nos services :\n• Données d'identification : nom, prénom, email, téléphone\n• Données de connexion : adresse IP, logs d'accès\n• Données de navigation : pages visitées, durée de session",
  "privacy.purpose.title": "Finalité du traitement",
  "privacy.purpose.text": "Vos données sont traitées pour :\n• Répondre à vos demandes de contact\n• Améliorer nos services\n• Respecter nos obligations légales",
  "privacy.storage.title": "Conservation et sécurité",
  "privacy.storage.text": "Vos données sont hébergées exclusivement au sein de l'Union Européenne.",
  "privacy.rights.title": "Vos droits",
  "privacy.rights.text": "Conformément au RGPD, vous disposez des droits d'accès, de rectification, d'effacement, de portabilité et d'opposition.",
  "privacy.cookies.title": "Cookies",
  "privacy.cookies.text": "Le site utilise des cookies strictement nécessaires au fonctionnement.",

  // ═══ COMPARISON TABLE ═══
  "compare.title": "Avant un chatbot classique. Après un agent IA vocal & textuel AIpreneur.",
  "compare.subtitle": "Une solution conçue pour répondre, qualifier, orienter, convertir et automatiser, sur le web, par message et par la voix, sans bloquer vos équipes.",
  "compare.col.capability": "Capacités",
  "compare.col.before": "Avant : chatbot standard",
  "compare.col.after": "Après : agent IA AIpreneur",
  "compare.row1.cap": "Compréhension des demandes",
  "compare.row1.before": "Réponses figées, souvent limitées à quelques scénarios",
  "compare.row1.after": "Compréhension contextuelle avec réponses textuelles et vocales",
  "compare.row2.cap": "Expérience utilisateur",
  "compare.row2.before": "Interaction rigide, parcours souvent frustrant",
  "compare.row2.after": "Conversation plus fluide, naturelle et orientée action",
  "compare.row3.cap": "Voix + texte",
  "compare.row3.before": "Le plus souvent textuel uniquement",
  "compare.row3.after": "Une même logique conversationnelle sur le vocal et le textuel",
  "compare.row4.cap": "Qualification des leads",
  "compare.row4.before": "Peu ou pas de qualification réelle",
  "compare.row4.after": "Qualification automatique selon les critères métier définis",
  "compare.row5.cap": "Prise de rendez-vous",
  "compare.row5.before": "Nécessite souvent une intervention manuelle",
  "compare.row5.after": "RDV, rappel ou transfert déclenchés automatiquement selon le scénario",
  "compare.row6.cap": "Multicanal",
  "compare.row6.before": "Souvent limité à un seul canal",
  "compare.row6.after": "Web, message, QR code, téléphone ou autres canaux selon intégration",
  "compare.row7.cap": "Intégration métier",
  "compare.row7.before": "Peu connecté aux outils internes",
  "compare.row7.after": "Connexion possible au CRM, agenda, support et workflows métier",
  "compare.row8.cap": "Pilotage de la performance",
  "compare.row8.before": "Peu de visibilité sur les résultats",
  "compare.row8.after": "KPI, volume, délais, conversion et suivi opérationnel",
  "compare.conclusion": "AIpreneur ne se contente pas de répondre : il aide à traiter, qualifier, orienter et convertir plus efficacement.",
  "compare.cta": "Découvrir l'agent IA",
};

export default fr;
